export type ExperimentValues = Record<string, string>

export type Experiments = ExperimentValues & {
  isEnabled: (spec: string) => boolean
}

// isEnabled is non-enumerable so the experiments object can still be iterated/serialized as plain values
export const toExperiments = (values: Record<string, string | Experiments['isEnabled']> = {}): Experiments => {
  const experiments = { ...values }
  Object.defineProperty(experiments, 'isEnabled', {
    value: (spec: string) => values[spec] === 'true' || values[spec] === 'B',
    enumerable: false,
  })
  return experiments as Experiments
}
